import {getLocalizationBasedOnLang} from '../../../data/models/User/UserInfo';

const english = {
  title: 'Video generation wizard',
  text: 'Generate AI videos',
  nextStep: 'Next step',
  skipStep: 'Skip step',
  exceptionsTitle: 'Exceptions',
  slideIgnoreAudioHeadingText: 'Slides or pages to silence',
  slideIgnoreAudioPlaceholderText:
    'Enter slide/page numbers (e.g., 1,2,3 or 4-6)',
  slideIgnoreHeadingText: 'Slides or pages to exclude',
  slideIgnorePlaceholderText: 'Enter slide/page numbers (e.g., 1,2,3 or 4-6)',
  textIgnoreHeadingText: 'Exclude text from audio',
  textIgnorePlaceholder: 'Enter all text to exclude, separated by commas',
  videoDurationTitle: 'Video duration',
  videoDurationLabel: 'Choose your video duration',
  contextLabel: 'Add context for narration (optional)',
  generateImagesTitle: 'AI media',
  aiImageNone: 'No',
  aiImageFew: 'A few',
  aiImageSome: 'Some',
  aiImageMostly: 'Mostly',
  aiImageEntirely: 'Entirely',
  generateImagesLabel:
    'Do you want to include AI-generated media in your final video?',
  imageStyleLabel: 'Choose an image style',
  mediaType: 'Choose the media type',
  images: 'Images',
  videos: 'Videos',
  imagesVideos: 'Both',
  generateVideosTitle: 'Include AI-generated videos',
  uploadPPTText: 'Upload your file',
  successMessage:
    'AI video is being generated. You will be notified once it is ready.',
  uploadPPTSubtitle: 'Accepted formats: pdf, docx, pptx',
  uploadPPTInfo1: 'Bring your content to life.',
  uploadPPTInfo2: ' Select your file below and start your video journey.',
  narrationTitle: 'Customize voice narration',
  voiceGenderHeading: 'Select the style and the tone of the narrator',
  languageDropdownHeading:
    'Select the language and the dialect of the narrator',
  slideNarrationType: 'Select the narration type',
  slideIgnoreAudioDurationTitle: 'Set display duration for muted slides',
  narrationGenderLabel: 'Select the voice of the narrator',
  generateVideo: 'Generate video',
  slideIgnoreAudioDurationWarning:
    'The duration must not exceed a limit of 10 minutes (00:10:00).',
  summaryReady: 'We’re ready to generate your video.',
  summaryInfo_NoMicrolesson:
    'Once started, this action cannot be canceled. Video generation may take some time, depending on the length of your uploaded file and the selected options. The final video will be available in your library when the process is complete.',
  summaryInfo_YesMicrolesson:
    'Once started, this action cannot be canceled. Video generation may take some time, depending on the length of your uploaded file and the selected options. The final video  will be available in your library and microlesson will be available in microlessons tab when the process is complete.',
  summary: 'Summary',
  summaryFile: 'File: ',
  summaryExceptions: 'Exceptions: ',
  summaryVideoDuration: 'Video duration: ',
  summaryMedia: 'AI media: ',
  summaryNarration: 'Narration: ',
  summaryRatio: ' ratio',
  summaryNoImages: 'No media',
  summaryMale: 'Male',
  summaryFemale: 'Female',
  summaryExclude: 'Exclude pages ',
  summaryMute: 'Mute pages ',
  summaryExcludePhrases: 'Exclude phrases',
  summaryFor: ' for ',
  summaryAvailableCredits: 'Available credits: ',
  summaryEstimatedCost: 'Estimated credit cost: ',
  summaryTone: 'Style & tone: ',
  exit: 'Cancel',
  sliderLeft: 'AI media',
  sliderRight: 'Your content',
  previousStep: 'Previous step',
  helpTipFile1:
    'For the best results, upload a PDF file. Word documents (.docx) or PowerPoints (.pptx) may lose formatting when converted to PDF.',
  helpTipFile2:
    'If you’d like to include AI media, please upload a landscape-oriented file.',
  helpTipFile3: '110 slides/pages limit per file.',
  helpTipFile4: 'Larger files will result in longer videos.',
  helpTipExclude1:
    'If there are specific pages, slides, or sections you’d like to exclude or modify in your final video, let us know here:',
  helpTipExclude2:
    'A) Slides or pages to silence: List any slides or pages, such as diagrams or image-only content, that you’d like to display visually without narration.',
  helpTipExclude3:
    'B) Slides or pages to exclude: Specify slide or page numbers you want completely removed from your video. These will not appear visually, and their content will not be narrated—essentially, think of this as deleting them from the final presentation.',
  helpTipExclude4:
    'C) Exclude text from audio: Provide details of any text, such as document authors, headers, or footers, that you’d like excluded from narration. The narrator will skip over these in the final video.',
  helpTipDuration:
    'Select "Short" for minimal narration, "Average" for standard detail, or "Long" for in-depth commentary on each slide. ',
  helpTipDuration2:
    'For videos containing math equations or formulas, we recommend choosing "Average" or "Long" to provide the best experience for learners.',
  helpTipDuration3:
    'Let tapybl AI contextualize based on your presentation, or upload relevant documents to provide additional guidance for the AI.',
  helpTipImageGen1:
    'Note: This section is experimental and can give unexpected results. Proceed with caution. You will be able to remove unwanted images using the timeline editor, but doing so will also remove your slide or document content from that portion of the video.',
  helpTipImageGen2:
    'Select an option to adjust how much of your video includes AI-generated media relative to your slide or document content:',
  helpTipImageGen3: '0%: Only your content is shown (no AI media).',
  helpTipImageGen4: '25%: A few AI media is included.',
  helpTipImageGen5: '50%: An equal mix of your content and AI media.',
  helpTipImageGen6: '75%: Mostly AI media with some of your content.',
  helpTipImageGen7: '100%: Only AI media is shown.',
  helpTipNarration:
    'Select the narrator’s voice, language, and dialect from the available options for your video.',
  helpTipNarration2:
    'Note: Translations impact the audio of your generated video, and not the visual elements.',
  helpTipNarration3:
    'Exact Narration: AI will follow your source file exactly as written.',
  helpTipNarration4:
    'Enhanced Narration: AI will add natural enhancements for a more engaging flow.',
  helpTipSummary: 'This action costs AI credits.',
  helpTipSummary2: 'Once you begin, the action cannot be canceled.',
  helpTipSummary3_NoMicrolesson:
    'Your credits will be updated after the video is generated.',
  helpTipSummary3_YesMicrolesson:
    'Your credits will be updated after the video and the microlesson is generated.',
  helpTitle: 'Tapybl tips',
  browse: 'Browse',
  fileOrientationWarning:
    'Note: AI media are only available for landscape-oriented files. This option is unavailable for your current upload. Please use a landscape-oriented file to enable AI images.',
  delete: 'Delete',
  calculating: 'Calculating...',
  slideNarrationTypeSummary: 'Narration type: ',
  narrationEnhanced: 'Enhanced',
  narrationExact: 'Exact',
  changeIcon: 'Change icon',
  generateMicrolessonStep_pageTitle: 'Generate microlesson',
  generateMicrolessonStep_generateMicrolessonLabel:
    'Do you want to generate a microlesson?',
  generateMicrolessonStep_titleField: 'Title',
  generateMicrolessonStep_titleDescription:
    'Choose a title for your microlesson',
  generateMicrolessonStep_includeBranching: 'Personalized pathways',
  generateMicrolessonStep_branchingSubtitle:
    'Allow your learners to select their own learning paths',
  generateMicrolessonStep_includeGrading: 'Verify learner comprehension',
  generateMicrolessonStep_assesmentSubtitle:
    'Verify learner comprehension levels using auto-generated assessments',
  generateMicrolessonStep_passingScore: 'Passing score',
  generateMicrolessonStep_passingScoreSubtitle:
    'Set the minimum passing score (0-100)',
  generateMicrolessonStep_enableAckNode: 'Enable acknowledgement node',
  generateMicrolessonStep_enableAckNodeSubtitle:
    'Insert an acknowledgement step in Microreels so learners can confirm understanding before continuing.',
  generateMicrolessonStep_generateMicroreelsLabel:
    'Do you want to generate microreels for this microlesson',
  helpTipMicrolesson:
    "Choosing to generate a microlesson allows you to get a structured, interactive learning asset from the same document you're using to create your video.",
  helpTipMicrolesson2:
    'Microlessons allow you to transform longer material into concise, high-impact lessons that are easier for learners to engage and complete.',
  helpTipMicrolesson3:
    "If you select Yes, you'll be able to give your microlesson a title, similar to when creating one manually.",
  helpTipMicrolesson4:
    'Selecting No will let you continue directly to the Summary step without generating a microlesson.',
  aiAssistantStep_pageTitle: 'Add AI assistant',
  aiAssistantStep_addAiAssistantLabel:
    'Would you like to add an AI assistant to this microlesson?',
  aiAssistantStep_addAiAssistantSubtitle:
    'An AI assistant is a great addition to a microlesson. It will allow learners to ask questions about anything in your knowledge base during the microlesson!',
  aiAssistantStep_nameField: 'Enter assistant name',
  aiAssistantStep_descriptionField: 'Describe your assistant',
  aiAssistantStep_descriptionPlaceholder:
    'Enter a description for your assistant',
  helpTipAiAssistant:
    'Adding an AI assistant gives learners real-time support as they move through your microlesson.',
  helpTipAiAssistant2:
    'Assistants help answer questions, reinforce key ideas, and provide personalized guidance.',
  helpTipAiAssistant3:
    'If your microlesson covers complex topics or decision-making steps, enabling an assistant can significantly improve learner engagement and comprehension.',
  helpTipAiAssistant4:
    'Selecting No will continue the flow without adding an assistant, and your microlesson will be published normally.',
  summaryAiAssistant_name: 'Assistant name',
  summaryAiAssistant_description: 'Description',
  summaryAiAssistant_responseStyle: 'Response style',
  summaryAiAssistant_communicationTone: 'Communication tone',
  videoSettingsTitle: 'Video settings',
  backgroundMusicLabel: 'Add background music',
  backgroundMusicTypeLabel: 'Select music type',
  helpTipBackgroundMusic:
    'If you enable background music, tapybl will automatically add a track based on your selected music type. Music is selected from predefined categories and will play for the full duration of the video. You can mute or unmute the music later in the video editor.',
  summaryBackgroundMusic: 'Background music: ',
};

const welsh = {
  ModalHeader: 'Cynhyrchydd fideo AI',
  text: 'Cynhyrchwch fideos AI',
  nextStep: 'Cam nesaf',
  skipStep: 'Can blaenorol',
  slideIgnoreAudioHeadingText: 'Sleidiau neu dudalennau i dawelu',
  slideIgnoreAudioPlaceholderText:
    'Nodwch rifau sleidiau neu dudalennau wedi’u separo gan gommasau, fel 1, 2, 4-6, 8.',
  slideIgnoreHeadingText: 'Sleidiau neu dudalennau i eithrio',
  slideIgnorePlaceholderText:
    'Nodwch rifau sleidiau neu dudalennau wedi’u separo gan gommasau, fel 1, 2, 4-6, 8.',
  textIgnoreHeadingText: "Eithrio testun o'r sain",
  textIgnorePlaceholder:
    'Nodwch yr holl frawddegau i eithrio, wedi’u separo gan gommasau',
  videoDurationTitle: 'Dewiswch hyd eich fideo',
  generateImagesTitle: 'Ychwanegwch delweddau a grëwyd gan AI',
  sliderHeading: 'Cyfran cynnwys i ddelwedd',
  uploadPPTText: 'Ychwanegwch eich ffeil',
  successMessage:
    'Mae fideo AI yn cael ei gynhyrchu. Byddwch yn cael gwybod unwaith y bydd yn barod',
  uploadPPTSubtitle: 'Fformatau a dderbynnir: pdf, docx, pptx',
  voiceGenderHeading: 'Dewiswch llais y llenor',
  languageDropdownHeading: 'Dewiswch iath y llenor',
  dialectDropdownHeading: 'Dewiswch ddiwyliant y llenor',
  narrationCustomization: 'Addasu adrodd llais',
  slideIgnoreAudioDurationTitle: 'Dewiswch y hyd ar gyfer sleidiau i daweithio',
  generateVideo: 'Cynhyrchwch fideo',
  slideIgnoreAudioDurationWarning:
    "Ni ddylai'r hyd fod yn fwy na 10 munud (00:10:00)",
  summaryReady: 'Rydym yn barod i gynhyrchu eich fideo',
  summaryInfo:
    'Ni ellir dychwelyd yr weithred hon. Sylwch y gall gynhyrchu fideo gymryd amser, yn dibynnu ar hyd eich ffeil a ychwanegwyd a’r dewisiadau cynhyrchu. Byddwch yn gallu gweld y fideo terfynol yn eich llyfrgell unwaith y bydd wedi gorffen',
  summary: 'Crynodeb',
  summaryFile: 'Ffeil:',
  summaryExceptions: 'Eithriadau:',
  summaryVideoDuration: 'Hyd y fideo:',
  summaryMedia: 'Cyfryngau AI:',
  summaryNarration: 'Adrodd:',
  summaryRatio: 'Cyfran',
  summaryNoImages: 'Dim delweddau',
  summaryExclude: 'Eithrwch tudalennau',
  summaryMute: 'Tawelwch tudalennau',
  summaryExcludePhrases: 'Eithrwch frawddeg',
  summaryFor: 'ar gyfer',
  exit: 'Canslo',
  sliderLeft: 'Delwaddau AI',
  sliderRight: 'Eich cynnwys',
  previousStep: 'Cam blaenorol',
  helpTipFile1: 'Ychwanegwch 1 ffeil',
  helpTipFile2: 'Terfyn 110 sleid ar gyfer pptx',
  helpTipFile3: 'Terfyn 110 tudalen ar gyfer pdf neu docx',
  helpTipFile4: 'Bydd ffeiliau mwy yn arwain at fideos hwy.',
  helpTipExclude1:
    'Os oes gennych gynnwys tudalen neu sleid, neu rannau cyfan yr hoffech eu cadw rhag cael eu harddangos yn eich fideo terfynol, gadewch i ni wybod yma:',
  helpTipExclude2:
    "A) Sleidiau neu Dudalennau i Dawelu: Os oes gennych dudalennau o ddiagramau neu sleidiau sy'n cynnwys dim ond delweddau yr hoffech eu harddangos yn weledol heb unrhyw adrodd, rhestrwch nhw ym.",
  helpTipExclude3:
    "B) Sleidiau neu Dudalennau i Eithrio: y rhifau sleid neu dudalen i'w heithrio o'ch cynnwys fideo a gynhyrchir. Ni fyddant yn ymddangos yn weledol, ac ni fydd eu cynnwys yn cael ei adrodd. Meddyliwch am hyn fel tudalennau yr hoffech eu dileu o'ch dogfen/pwyslais.",
  helpTipExclude4:
    'Eithrio Testun o’r Sain: unrhyw destun, megis awduron dogfen, pennawdau neu droednodau, i’w heithrio o’r adrodd. Bydd y darllenydd yn mynd heibio iddynt yn y fideo a gynhyrchir.',
  helpTipDuration:
    "Dewiswch 'Fer' ar gyfer adrodd lleiaf, 'Cyfartalog' ar gyfer manylion safonol, neu 'Hir' ar gyfer sylwebaeth fanwl ar bob sleid",
  helpTipImageGen1:
    'Nodyn: Mae’r adran hon yn arbrofol a gall roi canlyniadau annisgwyl. Parhewch gyda gofal. Byddwch yn gallu dileu delweddau annymunol gan ddefnyddio’r golygydd amserlinell, ond bydd gwneud hynny hefyd yn dileu cynnwys eich sleid neu ddogfen o’r rhan honno o’r fideo.',
  helpTipImageGen2:
    "Symudwch y llithrydd i ddewis hyd y cyfnod y bydd y delweddau'n cael eu harddangos mewn perthynas â chynnwys y sleid neu'r ddogfen. Bydd dewis 100 yn dangos yn unig eich cynnwys, tra bydd 0 yn dangos yn unig ddelweddau AI i'r gwylwyr.",
  helpTipNarration:
    'Dewiswch lais y darllenydd, y iaith, a’r naws o’r dewisiadau sydd ar gael ar gyfer eich fideo',
  helpTitle: 'Cynigion tapybl',
  helpTipNarration2:
    'Nodyn: Mae cyfieithiadau yn effeithio ar sain eich fideo a gynhyrchir, ac nid ar yr elfennau gweledol',
  helpTipSummary:
    "Mae'r weithred hon yn costio credydau AI. Bydd eich credydau'n cael eu diweddaru ar ôl cynhyrchu'r fideo.",
  changeIcon: 'Newid Eicon',
  generateMicrolessonStep_pageTitle: 'Microlesson',
  generateMicrolessonStep_generateMicrolessonLabel:
    'Ydych chi am gynhyrchu microlesson?',
  generateMicrolessonStep_titleField: 'Teitl',
  generateMicrolessonStep_titleDescription:
    'Dewiswch deitl ar gyfer eich microlesson',
  generateMicrolessonStep_includeBranching: 'Llwybrau personol',
  generateMicrolessonStep_branchingSubtitle:
    'Gadewch i’ch dysgwyr ddewis eu llwybrau dysgu eu hunain',
  generateMicrolessonStep_includeGrading: 'Dilysu dealltwriaeth dysgwyr',
  generateMicrolessonStep_assesmentSubtitle:
    'Dilysu lefelau dealltwriaeth dysgwyr gan ddefnyddio asesiadau a gynhyrchir yn awtomatig',
  generateMicrolessonStep_passingScore: 'Sgôr basio',
  generateMicrolessonStep_passingScoreSubtitle:
    'Gosod y sgôr basio lleiaf (0-100)',
  generateMicrolessonStep_enableAckNode: 'Galluogi nod cydnabod',
  generateMicrolessonStep_enableAckNodeSubtitle:
    "Ychwanegu pwynt gwirio cydnabod y mae'n rhaid i ddysgwyr ei gadarnhau cyn symud ymlaen",
  generateMicrolessonStep_generateMicroreelsLabel:
    'Ydych chi am gynhyrchu microreels ar gyfer y microlesson hwn',
  helpTipMicrolesson:
    'Bydd dewis creu microddosbarth yn caniatáu i chi gael ased dysgu strwythuredig, rhyngweithiol o’r un ddogfen rydych chi’n ei defnyddio i greu eich fideo.',
  helpTipMicrolesson2:
    'Mae microddosbarthiadau yn eich galluogi i drawsnewid deunydd hirach yn wersi cryno, effaith uchel sy’n haws i ddysgwyr ymgysylltu â nhw a’u cwblhau.',
  helpTipMicrolesson3:
    'Os dewiswch Ie, byddwch yn gallu rhoi teitl i’ch microddosbarth, yn debyg i’w greu’n llawlyfr.',
  helpTipMicrolesson4:
    "Bydd dewis Na yn eich galluogi i symud ymlaen yn uniongyrchol i'r cam Crynodeb heb greu microddosbarth.",
  aiAssistantStep_pageTitle: 'Ychwanegu cynorthwyydd AI',
  aiAssistantStep_addAiAssistantLabel:
    "Hoffech chi ychwanegu cynorthwyydd AI i'r microlesson hwn?",
  aiAssistantStep_addAiAssistantSubtitle:
    'Dewiswch a fydd dysgwyr yn derbyn cymorth amser real yn ystod profiad y wers.',
  aiAssistantStep_nameField: "Rhowch enw'r cynorthwyydd",
  aiAssistantStep_descriptionField: 'Disgrifiwch eich cynorthwyydd',
  aiAssistantStep_descriptionPlaceholder:
    'Rhowch ddisgrifiad ar gyfer eich cynorthwyydd',
  helpTipAiAssistant:
    "Mae ychwanegu cynorthwyydd AI yn rhoi cymorth amser real i ddysgwyr wrth iddynt symud trwy'ch microlesson.",
  helpTipAiAssistant2:
    'Mae cynorthwywyr yn helpu ateb cwestiynau, atgyfnerthu syniadau allweddol, a darparu arweiniad personol.',
  helpTipAiAssistant3:
    "Os yw'ch microlesson yn ymdrin â phynciau cymhleth neu gamau gwneud penderfyniadau, gall galluogi cynorthwyydd wella ymgysylltiad a dealltwriaeth dysgwyr yn sylweddol.",
  helpTipAiAssistant4:
    "Bydd dewis Na yn parhau'r llif heb ychwanegu cynorthwyydd, a bydd eich microlesson yn cael ei gyhoeddi fel arfer.",
  summaryAiAssistant_name: 'Enw cynorthwyydd',
  summaryAiAssistant_description: 'Disgrifiad',
  summaryAiAssistant_responseStyle: 'Arddull ymateb',
  summaryAiAssistant_communicationTone: 'Naws cyfathrebu',
  videoSettingsTitle: 'Gosodiadau fideo',
  backgroundMusicLabel: 'Ychwanegu cerddoriaeth gefndir',
  backgroundMusicTypeLabel: 'Dewiswch fath o gerddoriaeth',
  helpTipBackgroundMusic:
    'Gall ychwanegu cerddoriaeth gefndir wella naws ac ymgysylltiad cyffredinol eich fideo. Dewiswch o amrywiaeth o arddulliau cerddoriaeth i gyd-fynd â naws eich cynnwys.',
  summaryBackgroundMusic: 'Cerddoriaeth gefndir: ',
};

export const generateAIVideosText: any = getLocalizationBasedOnLang(
  english,
  welsh,
);
